import {
  FETCH_TOTAL_PROVISION_QUALITY,
  FETCH_CONNECTIONS_QUALITY,
  FETCH_BUSINESSES_QUALITY,
  FETCH_TOTAL_PROVISION_QUALITY_SUCCESS,
  FETCH_CONNECTIONS_QUALITY_SUCCESS,
  FETCH_BUSINESSES_QUALITY_SUCCESS,
  FETCH_TOTAL_PROVISION_QUALITY_FAILURE,
  FETCH_CONNECTIONS_QUALITY_FAILURE,
  FETCH_BUSINESSES_QUALITY_FAILURE,
  FETCH_USEFUL_STATS,
  FETCH_USEFUL_STATS_SUCCESS,
  FETCH_USEFUL_STATS_FAILURE,
} from './types';

const initialState = {
  isFetchingProvisionsTotalQuality: false,
  isFetchingConnectionsQuality: false,
  isFetchingBusinessesQuality: false,
  isFetchingUsefulStats: false,
  totalProvisionQuality: null,
  connectionsQuality: [],
  businessesQuality: [],
  usefulStats: null,
};

export default function connectionRunStatusReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOTAL_PROVISION_QUALITY:
      return {
        ...state,
        isFetchingProvisionsTotalQuality: true,
      };
    case FETCH_CONNECTIONS_QUALITY:
      return {
        ...state,
        isFetchingConnectionsQuality: true,
      };
    case FETCH_BUSINESSES_QUALITY:
      return {
        ...state,
        isFetchingBusinessesQuality: true,
      };
    case FETCH_TOTAL_PROVISION_QUALITY_SUCCESS:
    case FETCH_TOTAL_PROVISION_QUALITY_FAILURE:
      return {
        ...state,
        isFetchingProvisionsTotalQuality: false,
        totalProvisionQuality: action.totalProvisionQuality || null,
      };
    case FETCH_CONNECTIONS_QUALITY_SUCCESS:
    case FETCH_CONNECTIONS_QUALITY_FAILURE:
      return {
        ...state,
        isFetchingConnectionsQuality: false,
        connectionsQuality: action.connectionsQuality || [],
      };
    case FETCH_BUSINESSES_QUALITY_SUCCESS:
    case FETCH_BUSINESSES_QUALITY_FAILURE:
      return {
        ...state,
        isFetchingBusinessesQuality: false,
        businessesQuality: action.businessesQuality || [],
      };
    case FETCH_USEFUL_STATS:
      return {
        ...state,
        isFetchingUsefulStats: true,
      };
    case FETCH_USEFUL_STATS_SUCCESS:
    case FETCH_USEFUL_STATS_FAILURE:
      return {
        ...state,
        isFetchingUsefulStats: false,
        usefulStats: action.usefulStats || null,
      };
    default:
      return state;
  }
}
